import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { CheckboxInput } from '../checkbox/checkbox-input';
const b = bemClassBuilder('v-checkbox-group');
export const CheckboxGroup = observer(props => {
    const { name, options, selectedOptions, onChange, style, disabled, className } = props;
    return (_jsx("div", Object.assign({ className: b.block(undefined, className) }, { children: options.map(({ value: optionValue, text, children, disabled: optionDisabled }) => (_jsx(CheckboxInput, Object.assign({ label: text, name: name, optionValue: optionValue, value: selectedOptions.includes(optionValue), onChange: onChange, style: style, disabled: optionDisabled !== null && optionDisabled !== void 0 ? optionDisabled : disabled }, { children: children }), optionValue))) })));
});
CheckboxGroup.displayName = 'CheckboxGroup';
